import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "other-result" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "row d-flex" }
const _hoisted_4 = { class: "d-flex col-12 col-md-6 mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi-info-circle" }, null, -1)
const _hoisted_6 = { class: "ms-3" }
const _hoisted_7 = { class: "small mt-1" }
const _hoisted_8 = { class: "col-12 col-md-6" }
const _hoisted_9 = {
  key: 1,
  class: "container justify-content-center text-center p-7 ps-0 pe-0",
  style: {"opacity":"0.7"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OtherResultIntermiadiateBlock = _resolveComponent("OtherResultIntermiadiateBlock")!
  const _component_OtherResultIntermiadiate = _resolveComponent("OtherResultIntermiadiate")!
  const _component_MrUiKitCollapse = _resolveComponent("MrUiKitCollapse")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.otherResults.length)
      ? (_openBlock(), _createBlock(_component_InfiniteScroll, {
          key: 0,
          guard: _ctx.guard,
          containerClasses: ['pt-0']
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.t("common.results")), 1)
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherResults, (otherResult) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'other-result-' + otherResult.id,
                class: "mb-4"
              }, [
                _createVNode(_component_MrUiKitCollapse, null, {
                  collapse: _withCtx(() => [
                    _createVNode(_component_OtherResultIntermiadiate, {
                      id: otherResult.id,
                      attachments: otherResult.attachments,
                      generalNotes: otherResult.generalNotes
                    }, null, 8, ["id", "attachments", "generalNotes"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("h5", null, _toDisplayString(otherResult.competition), 1),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(otherResult.sport), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_OtherResultIntermiadiateBlock, { otherResult: otherResult }, null, 8, ["otherResult"])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["guard"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.t("common.noResults")), 1))
  ]))
}